import { Paragraph } from '@tmov/design-system';
import { Tokens } from '@tmov/design-system/theme/types';
import PropTypes from 'prop-types';
import React from 'react';

import { formatarMilhar, toTitleCase } from '../../../../../helpers/formatador';
import { Container, DemandaColumn } from './styles';

const DemandaDetails = ({ demanda }) => {
  const renderCidade = () => {
    const origem =
      demanda.cidadeCarregamento && demanda.estadoCarregamento
        ? `${toTitleCase(demanda.cidadeCarregamento)} - ${
            demanda.estadoCarregamento
          }`
        : '-';
    const destino =
      demanda.cidadeDescarregamento && demanda.estadoDescarregamento
        ? `${toTitleCase(demanda.cidadeDescarregamento)} - ${
            demanda.estadoDescarregamento
          }`
        : '-';
    return {
      origem,
      destino,
    };
  };

  return (
    <Container>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Produto
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {demanda.produto}
        </Paragraph>
      </DemandaColumn>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Origem
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {renderCidade().origem}
        </Paragraph>
      </DemandaColumn>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Destino
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {renderCidade().destino}
        </Paragraph>
      </DemandaColumn>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Saldo/Volume
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {`${formatarMilhar(demanda.saldo)} / ${formatarMilhar(
            demanda.volume
          )}`}
        </Paragraph>
      </DemandaColumn>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Cadência (ton)
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {formatarMilhar(demanda.cadencia)}
        </Paragraph>
      </DemandaColumn>
      <DemandaColumn>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[70]}
          style={{ marginBottom: '4px' }}
        >
          Previsão de embarque
        </Paragraph>
        <Paragraph
          variant="p2"
          color={Tokens.eixods.colors.neutral.grey[100]}
          fontWeight="semibold"
        >
          {demanda.numPrevistoCaminhoesHoje} Caminhõe(s)
        </Paragraph>
      </DemandaColumn>
    </Container>
  );
};

DemandaDetails.propTypes = {
  demanda: PropTypes.shape({
    status: PropTypes.number,
    produto: PropTypes.string,
    cidadeCarregamento: PropTypes.string,
    cidadeDescarregamento: PropTypes.string,
    estadoCarregamento: PropTypes.string,
    estadoDescarregamento: PropTypes.string,
    numPrevistoCaminhoesHoje: PropTypes.number,
    saldo: PropTypes.number,
    volume: PropTypes.number,
    cadencia: PropTypes.number,
  }).isRequired,
};

export default DemandaDetails;
